export default "__VITE_ASSET__c97e6058__"